import type { FC, PropsWithChildren } from "react";

export const AuthHeader: FC<PropsWithChildren> = props => {
	const {
		children
	} = props;

	return (
		<div className="flex flex-col items-center gap-1 text-center mb-6">
			{children}
		</div>
	);
};
